import { fromJS } from 'immutable'
import {
  USER_DELETE_MOVEMENT_REQUEST,
  USER_DELETE_MOVEMENT_SUCCESS,
  USER_DELETE_MOVEMENT_FAILURE,
  USER_DELETE_MOVEMENT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  // isAuthenticated: localStorage.getItem('access_token') !== null,
})

export default (state = init, action) => {
  switch (action.type) {
    case USER_DELETE_MOVEMENT_REQUEST:
      return state
        .set('isFetching', true)
    case USER_DELETE_MOVEMENT_SUCCESS:
      return state
        .set('isFetching', false)
        .set('type', 'success')
        .set('status', 'Deleted Successfully')
        .set('message', 'The data had successfully been updated')
        .set('employeeDeleteMovement', fromJS(action.payload.updatedUser))
    case USER_DELETE_MOVEMENT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('type', 'error')
        .set('status', 'Error')
        .set('employeeDeleteMovement', fromJS(action.payload.message))
        .set('message', fromJS(action.payload.response.message))
    case USER_DELETE_MOVEMENT_RESET:
      return state
        .delete('employeeDeleteMovement')
        .delete('type')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee/employee-delete-movement-reducer.js